import { render, staticRenderFns } from "./dxMemberGroup.vue?vue&type=template&id=43f402b0&"
import script from "./dxMemberGroup.vue?vue&type=script&lang=ts&"
export * from "./dxMemberGroup.vue?vue&type=script&lang=ts&"
import style0 from "./dxMemberGroup.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports